import { environment } from 'src/environments/environment';
import { tenantConfig } from 'src/environments/config_tenant';
import { configAppPages } from 'src/environments/config_app_pages';


/**
 * Esempio per disattivare le Thumb dalla immagini delle CARD
 */
export const BETA_IMAGE_BACKGROUND = tenantConfig.BETA_IMAGE_BACKGROUND;
export const BETA_IMAGE_CARD_OVER_BACKGROUND = tenantConfig.BETA_IMAGE_CARD_OVER_BACKGROUND;



export const TENANT_LIST = {
  VISITGALATONE: 'VISITGALATONE',
  PUGLIAIMPERIALE: 'PUGLIAIMPERIALE'
};
export const VERS_GALATONE = environment.api.tenantName.toUpperCase() === TENANT_LIST.VISITGALATONE;
export const VERS_PUGLIAIMP = environment.api.tenantName.toUpperCase() === TENANT_LIST.PUGLIAIMPERIALE;


export const ANALYTICS_TRACKER_ID = environment.analyticsTrackerId;
export const TENANT = tenantConfig.TENANT_LANGUAGE_PREFIX;
export const COMUNE_ATTUALE = tenantConfig.COMUNE_DETAIL;

export const COOKIE_CONSENT = 'displayCookieConsent-11';
export const LOCALE_UUID = 'locale_uuid';

export const RICHIEDI_SITO_DESKTOP = 'RICHIEDI_SITO_DESKTOP';
export const RICHIEDI_SITO_DESKTOP_DURATION_DAYS = 365;




// 1 anno
export const COOKIE_CONSENT_DURATION_DAYS = 365;
// 1 minuto
//export const COOKIE_CONSENT_DURATION_DAYS = 0.00069;
// 10 minuti
//export const COOKIE_CONSENT_DURATION_DAYS = 0.0069;




// Salvataggio in locale per il motore di raccomandazione
export const RACC_ENGINE_STORAGE_LIMIT_RECORD = 50;
export const RACC_ENGINE_STORAGE_NAME = 'RACCOMANDATION_STORAGE_NAVIGATION';

/* Puntamento ai servizi del motore di raccomandazione */
export const API_RECOMM_BASE_URL = '';

export const RECOMM_ENABLED = environment.REngine.enable;
export const RECOMM_DEBUG = environment.REngine.debug;

export const BASE_EVENTS = environment.REngine.urlEvents;
export const BASE_QUERIES = environment.REngine.urlQuery;
export const RECOMM_ACCESS_KEY = environment.REngine.accessKey;

export const RECOMM_ALGORITHM_METHOD_HYBRID = 'hybrid';
export const RECOMM_ALGORITHM_METHOD_CONTENT = 'content';//sarà content
export const RECOMM_ALGORITHM_METHOD_COLLABORATIVE = 'collaborative'; //sarà collaborative
export const RECOMM_ALGORITHM_METHOD_CONTEXT = 'context';//sarà content

export const RECOMM_CONFIG = tenantConfig.REngine; // Totale dei suggerimenti
export const DISTANCE_THRESOLD_IN_PLACE = tenantConfig.REngine.distanceThresoldInPlace; //Limite in km per capire se mi trovo in zona o a distanza




/* Puntamento ai servizi di kubernetes */
export const API_BASE_URL = environment.api.baseUrl;
export const BASE_POI_URL = 'poi/';
export const BASE_EVENT_URL = 'event/';
export const BASE_FAVORITE_URL = 'favourite/';
export const BASE_MEDIA_URL = 'media/';
export const BASE_SOCIAL_URL = 'social/';
export const BASE_ITINERARY_URL = 'itinerary/';
export const BASE_UTILITIES_URL = 'utilities/';
export const BASE_GENERIC_CONTENT_URL = 'genericcontent/';
export const BASE_TAG_URL = 'tags/';

export const BASE_APP_URL = '/';
export const BASE_DETAIL_URL = 'detail/';

export const BASE_COMMENT_URL = 'comment/';
export const BASE_RATE_URL = 'rate/';

export const LIST_POI_URL = 'public/';
export const LIST_EVENT_URL = 'public/';
export const LIST_COMMENT_URL = 'public/';
export const LIST_RATE_URL = 'public/';
export const LIST_ITINERARY_URL = 'public/';

export const PUBLIC_URL = 'public/';

export const EDITOR_URL = 'editor/';
export const USER_URL = 'user/';
export const REPLY_URL = 'reply/';

export const SOCIAL_AUTH_METADATA_BASE_URL = 'user-auth/info/?landId=' + environment.api.tenantId;


/**
 * Variabili utili alla configurazioni del servizio eTicketing
 * 
 */

export const ETICKETING_MEDIA_BASE_URL = environment.api.tenantIdEticketingUrl;
export const ETICKETING_BASE_URL = environment.api.tenantIdEticketingUrl;
export const ETICKETING_API_URL = 'api/'
export const ETICKETING_PUBLIC_URL = 'public/'
export const ETICKETING_EVENTS_URL = 'events/'
export const ETICKETING_EVENT_URL = 'event/'
export const ETICKETING_ORGANIZATION_URL = 'organization/'
export const ETICKETING_NAME_URL = 'name/'
export const ETICKETING_CLASSIFICATIONS_URL = 'classifications/'
export const ETICKETING_ALL_URL = 'all/'


export const GEOCODE_LOCATION_URL_BASE = 'https://eu1.locationiq.com/v1/search.php?limit=10&countrycodes=it&format=json&viewbox=' + tenantConfig.GEOCODE_LOCATION_VIEWBOX + '&bounded=1&key=';
export const GEOCODE_LOCATION_URL_SEARCH = '&q=';
export const GEOCODE_LOCATION_KEY = '7e6f21b69e37d4';






//export const MEDIASERVER_BASE_URL = 'http://web40.linksmt.it/turismo-media-server/';
export const MEDIASERVER_DOWNLOAD_URL = `public/downloadFile/`;
export const MEDIASERVER_DOWNLOAD_EDITOR_URL = `editor/downloadFile/`;
export const MEDIASERVER_UPLOAD_URL = `uploadFile/`;
export const MEDIASERVER_UPLOAD_MULTIPART_URL = `uploadMultipleFiles/`;

//Distanza in km
export const THEMES = {
  POI: 'POI',
  EVENTS: 'EVENTS',
  ITINERARY: 'ITINERARY',
}

export const NEARME_LIMIT_DISTANCE = 650;
export const POY_TYPE = {
  EVENT: {
    KEY: '04'
  },
  ATTRACTOR: {
    KEY: '01'
  },
  RESTAURANT: {
    KEY: '02'
  },
  ACCOMODATION: {
    KEY: '03'
  },
  ITINERARY: {
    KEY: '05'
  },
  CITY: {
    KEY: '06'
  }
};
export const TYPE_EVENTS_PERIOD = {
  PERIOD_ERROR: -1,
  PERIOD_ONLY_START_DATE: 0,
  PERIOD_SAME_DATE: 1,
  PERIOD_SAME_MONTH: 2,
  PERIOD_DIFFERENT_MONTH_SAME_YEAR: 3,
  PERIOD_DIFFERENT_YEAR: 4
};

export const TYPE_EVENTS = { CODE: 'EVENTS', URL: 'events' };
export const TYPE_POIS = { CODE: 'POIS', URL: 'pois-list' };
export const STORAGE_KEY = 'favourite';
export const STORAGE_KEY_POSITION = 'position';
export const STORAGE_KEY_USER_POSITION = 'user_position';

export const STORAGE_KEY_TOREMOVE = 'favouriteToRemove';
export const STORAGE_KEY_GOTOLOGIN = 'gotologin';

export const RADIUS_FROM = 5;
export const RADIUS_TO = 1000;
export const RADIUS_STEP = 5;
export const RADIUS_UOM = 'Km';

export const TIME_UOM = 'H';

export const ELENCO_RISULTATI_MAXPAGE = 10;


//Quanto minuti devo tenere in cache i dati
export const TTL_EVENTS = 1; //5
export const TTL_POI = 0.01; //5;
export const TTL_FAVORITE = 10;
export const TTL_COMMENTS = 10;
export const TTL_MEDIA = 1;
export const TTL_RATINGS = 1;
export const TTL_ITINERARY = 10; //5;
export const TTL_RECOMMENDATION = 0.01;
export const TTL_MULTI_TENANT = 240;


export const TYPE_COMMENT = 'comment';
export const TYPE_REPLY = 'reply';

export const EVENTS = {
  SORT_BY: {
    STAR_DATE: 'opening.startDate'
  }
};
export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC'
};
export const LANGUAGE = {
  DEFAULT: 'it',
  IT: 'it',
  EN: 'en'
};

export const ICONS = {
  FAVOURITE: {
    ON: 'assets/svg/bookmark-on.svg',
    OFF: 'assets/svg/bookmark-off.svg'
  }
};

export const COMMENTS = {
  STATUS: {
    NEW: 'NEW',
    TO_VERIFIED: 'TO_VERIFIED',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    CANCELED: 'CANCELED'
  }
};

//Determina se l'applicazione è pensato per uso Comunale oppure un uso ad ampio raggio
//Indirizzo - ADDRESS
//Comune - CITY
//Completo - CITY_ADDRESS
export const MODE_APP_LOCALE = tenantConfig.MODE_APP_LOCALE;
export const MODE_APP_LOCALE_ADDRESS = 'ADDRESS';
export const MODE_APP_LOCALE_CITY = 'CITY';
export const MODE_APP_LOCALE_CITY_ADDRESS = 'CITY_ADDRESS';


//L'albero di Navigazione è salvato nella configurazione del TENANT
export const APP_PAGES = configAppPages.APP_PAGES;

export const NAVIGATION = configAppPages.navigation;


export const APP_PAGES_LOGIN = {
  title: 'SETTINGS.SETTINGS_LOGIN',
  url: '/login',
  icon: 'log-in',
  isVisible: false,
  forDesktop: false,
  child: []
};

export const APP_PAGES_LOGOUT = {
  title: 'SETTINGS.SETTINGS_LOGOUT',
  url: '/logout',
  icon: 'log-out',
  isVisible: false,
  forDesktop: false,
  child: []
};
